var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"search",staticClass:"location-search",attrs:{"input":function (value) { return _vm.$emit('update:value', value); },"placeholder":_vm.placeholder},domProps:{"value":_vm.value}})}
var staticRenderFns = []

export { render, staticRenderFns }